// extracted by mini-css-extract-plugin
module.exports = {"WhatsNew":"WhatsNewBannerHome_WhatsNew__3O-cz"};